import { t } from "i18next";
import { DataTableData } from "../../../../../components/deprecated/DataTable/DataTable";

import { Utilities } from "../../../../../utils/utilities";

import { DataObjectHelper, DataObjectType } from "../../DataObjects/DataObjectHelper";
import { FirebaseDataBooleanField } from "../../DataObjectField/Generic/FirebaseDataBooleanField";
import { FirebaseDataDateField } from "../../DataObjectField/Generic/FirebaseDataDateField";
import { FirebaseDataNumberField } from "../../DataObjectField/Generic/FirebaseDataNumberField";
import { FirebaseDataStringField } from "../../DataObjectField/Generic/FirebaseDataStringField";

export class LandaxTaskDataHelper extends DataObjectHelper<DataObjectType> {
  id = () => "landax_tasks";
  displayName = () => t("main.pushNotifications");

  Id = new FirebaseDataStringField<DataObjectType>("Id", "ID", (data) => (typeof data.Id === "string" ? data.Id : ""));
  Description = new FirebaseDataStringField<DataObjectType>("Description", t("main.description"), (data) =>
    typeof data.description === "string" ? data.description : ""
  );
  IsClosed = new FirebaseDataBooleanField<DataObjectType>("IsClosed", t("main.solved"), (data) =>
    typeof data.IsClosed === "boolean" ? data.IsClosed : false
  );
  TypeId = new FirebaseDataNumberField<DataObjectType>("TypeId", "TypeId", (data) => (typeof data.TypeId === "number" ? data.TypeId : undefined));
  DoneDate = new FirebaseDataDateField<DataObjectType>("DoneDate", t("main.doneDate"), (data) => Utilities.getDateFromTimestamp(data.DoneDate));

  allFields() {
    return [this.Id, this.Description, this.IsClosed, this.TypeId, this.DoneDate];
  }
  getAllDataTableDatas(documents: DataObjectType[]): DataTableData[] {
    return [];
  }
}

